import { render, staticRenderFns } from "./SearchServiceNew.vue?vue&type=template&id=53fe0774"
import script from "./SearchServiceNew.vue?vue&type=script&lang=ts"
export * from "./SearchServiceNew.vue?vue&type=script&lang=ts"
import style0 from "./SearchServiceNew.vue?vue&type=style&index=0&id=53fe0774&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports